import { useEffect, useState } from "react";
import { SPORTS, fmtDate, fmtStat } from "@/constants/sports";
import { api } from "@/lib/api";

const RESULT = { W: "text-emerald-400", L: "text-red-400", T: "text-slate-300" };

export const GameLog = ({ playerId, sport }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/players/${playerId}/games`).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, [playerId]);
  const cols = SPORTS[sport]?.logColumns || [];

  if (!items) return <p className="text-sm text-slate-500">Loading games</p>;
  if (!items.length) return <p data-testid="gamelog-empty" className="text-sm text-slate-500">No games recorded yet this season.</p>;

  return (
    <div className="overflow-x-auto rounded-lg border border-slate-800">
      <table data-testid="gamelog-table" className="w-full min-w-[640px] text-sm">
        <thead className="bg-[#0B0F19]">
          <tr className="text-left">
            <th className="eyebrow px-4 py-3 font-normal">Date</th>
            <th className="eyebrow px-4 py-3 font-normal">Opponent</th>
            <th className="eyebrow px-4 py-3 font-normal">Result</th>
            {cols.map(([k, l]) => <th key={k} className="eyebrow px-3 py-3 text-right font-normal">{l}</th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-800">
          {items.map((g) => (
            <tr key={g.game_id} data-testid={`gamelog-row-${g.game_id}`} className="transition-colors hover:bg-[#0B0F19]/60">
              <td className="whitespace-nowrap px-4 py-3 font-data text-xs text-slate-400">{fmtDate(g.date)}</td>
              <td className="px-4 py-3">
                <span className="flex items-center gap-2">
                  <span className="w-4 font-data text-[11px] text-slate-500">{g.home ? "vs" : "@"}</span>
                  {g.opponent.logo && <img src={g.opponent.logo} alt="" className="h-5 w-5 object-contain" />}
                  <span className="truncate">{g.opponent.name}</span>
                </span>
              </td>
              <td className={`whitespace-nowrap px-4 py-3 font-data text-xs font-bold ${RESULT[g.result] || "text-slate-500"}`}>
                {g.result ? `${g.result} ${g.score}` : "—"}
              </td>
              {cols.map(([k]) => <td key={k} className="px-3 py-3 text-right font-data text-white">{fmtStat(k, g.stats[k] ?? 0)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
